import React from 'react';
import { useTranslation } from 'react-i18next';
import { NoDataContainer } from 'style/Main';

const NotAvailable = () => {
  const { t } = useTranslation();
  return (
    <NoDataContainer>
      <div>
        <span>{t('This video is no longer available.')}</span>
        <p>
          {t(
            'This video has been deleted by the sender, or the account associated with this video is no longer active.'
          )}
        </p>
      </div>
    </NoDataContainer>
  );
};

export default NotAvailable;
